import { PrequalWizard } from "./PrequalWizard";
import { DebtSlider } from "./DebtSlider";
import { CardGame } from "./CardGame";
import { Timeline } from "./Timeline";

// Interactive sections slotted after chapter N (1-based) on /mortgages/pre-approval/.
export const PREAPP_EXTRAS = { 1: PrequalWizard, 2: DebtSlider, 3: CardGame, 4: Timeline };
